import React from 'react';
import PropTypes from 'prop-types';

import config from '../../../config';

function AppLogo({ useDefaultUrl, style, ...props }) {
    return (
        <img
            src={`${useDefaultUrl ? config.url : config.staticUrl}assets/images/logo-monlivresms-2.png`}
            alt={config.application.name}
            width="168"
            height="46"
            style={{ height: 'auto', ...style }}
            {...props}
        />
    );
}

AppLogo.propTypes = {
	useDefaultUrl: PropTypes.bool,
};

export default AppLogo;
